import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { search } from 'components/CustomInput/utils/search';

// material-ui components
import withStyles from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';

// core components
import CustomInput from 'components/CustomInput/CustomInput';

// style
import customAutoCompleteStyle from 'components/CustomInput/style/customAutoCompleteStyle';

let myTimeout = null;

class CustomAutoComplete extends Component {
  state = {
    results: [],
    open: false,
  };

  handleToogle = () => {
    this.setState({ open: !this.state.open });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleChange = (event, data, maxResults) => {
    const { value } = event.target;

    clearTimeout(myTimeout);
    myTimeout = setTimeout(() => {
      this.setState({
        results: search(value, data, maxResults),
      });
    }, 300);

    this.props.handleChange(event);
  };

  handleSelect = (name, id) => {
    this.setState({ open: false });
    this.props.handleSelect(name, id);
  };

  render() {
    const { open } = this.state;
    const {
      classes,
      className,
      dropup,
      labelText,
      data,
      additionalValues,
      maxResults,
      success,
      error,
      id,
      helpText,
      value,
      readOnly,
    } = this.props;

    let results = [...this.state.results, ...additionalValues];

    return (
      <div className={classes.container}>
        <CustomInput
          disabled
          success={success}
          error={error}
          labelText={labelText}
          helpText={helpText}
          id={id}
          formControlProps={{
            fullWidth: true,
            ...(className && { className }),
          }}
          inputProps={{
            value: value,
            onChange: (event) => this.handleChange(event, data, maxResults),
            readOnly,
            onClick: this.handleOpen,
          }}
        />
        {results.length > 0 && open && !readOnly && (
          <ClickAwayListener onClickAway={this.handleToogle}>
            <Grow
              in={open}
              id='menu-list'
              style={dropup ? { transformOrigin: '0 100% 0' } : { transformOrigin: '0 0 0' }}>
              <Paper className={classes.dropdown}>
                <MenuList role='menu' className={classes.menuList}>
                  {results.map((result, key) => {
                    return (
                      <MenuItem
                        key={key}
                        onClick={() => this.handleSelect(result.name, result._id)}
                        onSelect={() => this.handleSelect(result.name, result._id)}
                        className={classes.dropdownItem}>
                        {result.name}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </Paper>
            </Grow>
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

CustomAutoComplete.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  labelText: PropTypes.node,
  data: PropTypes.array,
  additionalValues: PropTypes.array,
  error: PropTypes.bool,
  success: PropTypes.bool,
  readOnly: PropTypes.bool,
};

CustomAutoComplete.defaultProps = {
  additionalValues: [],
  readOnly: false,
};

export default withStyles(customAutoCompleteStyle)(CustomAutoComplete);
